import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { registerLogoutCallback } from 'api/apiBase/axios';

import {
  authSlice,
  chartsSlice,
  dictionarySlice,
  filtersSlice,
  pairConfigsSlice,
  pairConnectedBots,
  pairsSlice,
  projectsSlice,
  uiSlice,
} from './slices';
import { logout } from './slices/auth';

const store = configureStore({
  reducer: {
    auth: authSlice,
    projects: projectsSlice,
    dictionary: dictionarySlice,
    ui: uiSlice,
    pairs: pairsSlice,
    pairConnectedBots: pairConnectedBots,
    filters: filtersSlice,
    pairConfigs: pairConfigsSlice,
    charts: chartsSlice,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
});

export type RootStore = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useTypedSelector: TypedUseSelectorHook<RootStore> = useSelector;
export const useTypedDispatch: () => AppDispatch = useDispatch;

registerLogoutCallback(() => {
  store.dispatch(logout());
});

export default store;
